import { Etapa } from '@src/shared/models/etapa';
import { useAppStore } from '@src/shared/zustand/store';

export const setEtapa = (etapa: Etapa) => useAppStore.setState({ etapa });

export const setError = (error: string) => useAppStore.setState({ error });

export const clearError = () =>
  useAppStore.setState({ error: null, etapa: null });
